<template>
  <div class="text-gray-500 text-center mx-auto w-3/4 max-w-[350px]">
    <div class="flex justify-center my-4">
      <PermissionStatusCircle icon="icon-radio" ready></PermissionStatusCircle>
    </div>
    <div class="font-bold text-lg text-gray-700">Bluetooth</div>
    <p class="my-6">
      Bluetooth is required to <span class="text-gray-700 font-medium">connect</span> to and
      <span class="text-gray-700 font-medium">configure</span> nearby equipment through the
      <span class="text-gray-700 font-medium">DirectConnect</span> tool.
    </p>
    <div v-if="blePermission.ready">
      <div class="text-lg font-bold text-gray-700">Good to go!</div>
      <p>NCSS has the necessary access to Bluetooth<br /><span class="text-gray-700 font-bold">Thank you</span></p>
    </div>
    <PermissionDialog v-else>Allow "NCSS" to find Bluetooth devices?</PermissionDialog>
  </div>
</template>

<script setup lang="ts">
import PermissionStatusCircle from '@/components/permissions/PermissionStatusCircle.vue';
import PermissionDialog from './PermissionDialog.vue';
import { useBlePermission } from '@/stores/permissions/ble-permission.store';

const blePermission = useBlePermission();
</script>

<style scoped></style>
